module.exports = __webpack_public_path__ + "ff355e8f1e293c07a3c5b48734b61fd3.png";